<ng-container
  *ngrxLet="
    installationFeaturesStore.selectUpdateFeatureLoading$ | async as selectUpdateFeatureLoading
  "
>
  <div class="setting-container" [class.disabled]="selectUpdateFeatureLoading">
    <div>
      <div class="flex flex-row gap-3">
        <mat-slide-toggle
          [checked]="feature | featureValue: featurePropertyKey.active"
          [disabled]="
            selectUpdateFeatureLoading ||
            (feature.properties?.active?.value
              ? !(feature | executable: featureCommands.deactivate)
              : !(feature | executable: featureCommands.activate))
          "
          (change)="hemsSettingChange($event, feature)"
        ></mat-slide-toggle>
        <div class="flex flex-col">
          <div class="flex flex-row gap-[8px] justify-start items-center">
            <p class="text-[18px] font-normal">{{ title }}</p>
            <app-pill
              *ngIf="isBetaFeature"
              class="lt-md:!hidden gt-sm:!block"
              [type]="pillType.brand"
              >{{ '+HEMS.SETTINGS.OPTIMIZATIONS.BETA' | translate }}</app-pill
            >
          </div>
          <span class="setting-description">
            <ng-content></ng-content>
            <div *ngIf="infoText" class="flex flex-row gap-[8px] items-center mt-[8px]">
              <mat-icon>info</mat-icon>
              <vi-text size="small">{{ infoText }}</vi-text>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
